export const categories = [
  {
    slug: 'dongya',
    name: '东亚专区',
    description: '聚焦中日韩等东亚地区文化、科技与生活方式',
    icon: 'ri-earth-line',
    color: 'primary',
    count: 128,
  },
  {
    slug: 'dongnanya',
    name: '东南亚专区',
    description: '探索东南亚热带风情、旅游与美食文化',
    icon: 'ri-ship-line',
    color: 'accent',
    count: 96,
  },
  {
    slug: 'nanya',
    name: '南亚专区',
    description: '印度、巴基斯坦等南亚地区深度内容',
    icon: 'ri-landscape-line',
    color: 'secondary',
    count: 74,
  },
  {
    slug: 'wenhua',
    name: '亚洲文化',
    description: '传统与现代交织的亚洲文化艺术鉴赏',
    icon: 'ri-palette-line',
    color: 'primary',
    count: 156,
  },
  {
    slug: 'yule',
    name: '亚洲娱乐',
    description: '影视、音乐、综艺等亚洲流行娱乐资讯',
    icon: 'ri-movie-2-line',
    color: 'accent',
    count: 203,
  },
  {
    slug: 'zixun',
    name: '亚洲资讯',
    description: '亚洲各国最新时事、经济与科技动态',
    icon: 'ri-newspaper-line',
    color: 'secondary',
    count: 312,
  },
  {
    slug: 'chanpin',
    name: '产品服务',
    description: '亚洲优质产品推荐与服务资源对接',
    icon: 'ri-shopping-bag-3-line',
    color: 'primary',
    count: 89,
  },
  {
    slug: 'shenghuo',
    name: '生活方式',
    description: '亚洲各地独特生活方式与日常美学',
    icon: 'ri-heart-line',
    color: 'accent',
    count: 145,
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; border: string; badge: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    border: 'border-primary-200',
    badge: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    border: 'border-accent-200',
    badge: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    border: 'border-secondary-200',
    badge: 'bg-secondary-500',
  },
};